import {
    IDescriptionLabels
} from "libraries/module/formbuilder/fields/form-field/components/field-description/field-description.component";
import { Yii } from "libraries/interfaces/Yii";
import {
    DATE_EXPRESSION_DETAILS,
    DATE_EXPRESSION_FIELD_INTRO, STAY_EXPRESSION_DETAILS,
    STAY_EXPRESSION_FIELD_INTRO
} from "libraries/date/date-shared-wording";
import { BookingSearchParameters } from "libraries/interfaces/IBookingSearchParameters";

/**
 * TEMPLATE LABELS TRANSLATED
 */
export const TEMPLATE_LABELS: { [key: string]: string } = {
    bookingSearch: Yii.t('wui-sasha-js', 'Recherche de dossiers'),
    newSearch: Yii.t('wui-sasha-js', 'Nouvelle recherche'),
    booking: Yii.t('wui-sasha-js', 'Dossier'),
    persons: Yii.t('wui-sasha-js', 'Personnes'),
    journey: Yii.t('wui-sasha-js', 'Voyage'),
    submit: Yii.t('wui-sasha-js', 'Rechercher'),
    segment: Yii.t('wui-sasha-js', 'Segment'),
    dateField: Yii.t('wui-sasha-js', 'Ajouter un critère de date'),
    missingDateField: Yii.t('wui-sasha-js', 'Absente'),
    afidiumServiceField: Yii.t('wui-sasha-js', 'Ajouter un critère sur les services'),
};


/**
 * FIELD DESCRIPTIONS TRANSLATED
 */
export const FIELD_LABELS: { [key: string]: string } = {
    [BookingSearchParameters.text]: Yii.t('wui-sasha-js', 'Recherche de dossiers'),
    [BookingSearchParameters.code]: Yii.t('wui-sasha-js', 'Références'),
    [BookingSearchParameters.host]: Yii.t('wui-sasha-js', 'Systèmes'),
    [BookingSearchParameters.type]: Yii.t('wui-sasha-js', 'Contenu'),
    agencyList: Yii.t('wui-sasha-js', 'Agences (liste)'),
    agentList: Yii.t('wui-sasha-js', 'Agents (liste)'),
    agency: Yii.t('wui-sasha-js', 'Agences (recherche étendue)'),
    agent: Yii.t('wui-sasha-js', 'Agents (recherche étendue)'),
    [BookingSearchParameters.xStatus]: Yii.t('wui-sasha-js', 'Statuts'),
    [BookingSearchParameters.midOffice]: Yii.t('wui-sasha-js', 'Statuts Mid-Office'),
    [BookingSearchParameters.issueStatus]: Yii.t('wui-sasha-js', "Statuts d'émission"),
    [BookingSearchParameters.retentionReason]: Yii.t('wui-sasha-js', "Raison de rétention"),
    [BookingSearchParameters.xType]: Yii.t('wui-sasha-js', 'Type'),
    [BookingSearchParameters.from]: Yii.t('wui-sasha-js', "Lieux d'origine"),
    [BookingSearchParameters.to]: Yii.t('wui-sasha-js', 'Lieux de destination'),
    [BookingSearchParameters.carrier]: Yii.t('wui-sasha-js', 'Compagnies principales'),

    [BookingSearchParameters.person]: Yii.t('wui-sasha-js', 'Voyageur / Client'),
    [BookingSearchParameters.hasMembershipCard]: Yii.t('wui-sasha-js', 'Carte de voyageur fréquent'),

    [BookingSearchParameters.seatStatus]: Yii.t('wui-sasha-js', 'Statuts natifs des vols'),
    [BookingSearchParameters.whenCreated]: Yii.t('wui-sasha-js', 'Date de création'),
    [BookingSearchParameters.whenAgencyBookingCreated]: Yii.t('wui-sasha-js', 'Date de création du dossier Mid-Office'),
    [BookingSearchParameters.pendingPercentageMax]: Yii.t('wui-sasha-js', 'Valeur restante des billets Max (%)'),
    [BookingSearchParameters.pendingPercentageMin]: Yii.t('wui-sasha-js', 'Valeur restante des billets Min (%)'),
    [BookingSearchParameters.pendingValueMax]: Yii.t('wui-sasha-js', 'Valeur restante des billets Max (€)'),
    [BookingSearchParameters.pendingValueMin]: Yii.t('wui-sasha-js', 'Valeur restante des billets Min (€)'),
    [BookingSearchParameters.paidPercentageMax]: Yii.t('wui-sasha-js', 'Montant réglé Max (%)'),
    [BookingSearchParameters.paidPercentageMin]: Yii.t('wui-sasha-js', 'Montant réglé Min (%)'),
    [BookingSearchParameters.paidValueMax]: Yii.t('wui-sasha-js', 'Montant réglé Max (€)'),
    [BookingSearchParameters.paidValueMin]: Yii.t('wui-sasha-js', 'Montant réglé Min (€)'),
    [BookingSearchParameters.duePercentageMax]: Yii.t('wui-sasha-js', 'Solde Max (%)'),
    [BookingSearchParameters.duePercentageMin]: Yii.t('wui-sasha-js', 'Solde Min (%)'),
    [BookingSearchParameters.dueValueMax]: Yii.t('wui-sasha-js', 'Solde Max (€)'),
    [BookingSearchParameters.dueValueMin]: Yii.t('wui-sasha-js', 'Solde Min (€)'),

    [BookingSearchParameters.ticketMatchAll]: Yii.t('wui-sasha-js', 'Recherche de coupon exclusive'),
    [BookingSearchParameters.ticketSectorFrom]: Yii.t('wui-sasha-js', "Lieux d'origine"),
    [BookingSearchParameters.ticketSectorTo]: Yii.t('wui-sasha-js', "Lieux de destination"),
    [BookingSearchParameters.ticketSectorBeginDate]: Yii.t('wui-sasha-js', 'Date de départ'),
    ticketSectorBeginDateMin: Yii.t('wui-sasha-js', 'Départ min'),
    ticketSectorBeginDateMax: Yii.t('wui-sasha-js', 'Départ max'),
    [BookingSearchParameters.ticketFlightNumber]: Yii.t('wui-sasha-js', 'Numéro de vol'),
    [BookingSearchParameters.ticketStatus]: Yii.t('wui-sasha-js', 'Statut du coupon'),
    [BookingSearchParameters.ticketNativeStatus]: Yii.t('wui-sasha-js', 'Statuts des coupons du billet'),
    [BookingSearchParameters.ticketSectorCarrier]: Yii.t('wui-sasha-js', 'Companies'),

    whenCreatedMin: Yii.t('wui-sasha-js', 'Création min'),
    whenCreatedMax: Yii.t('wui-sasha-js', 'Création max'),
    whenAgencyBookingCreatedMin: Yii.t('wui-sasha-js', 'Création Mid-Office min'),
    whenAgencyBookingCreatedMax: Yii.t('wui-sasha-js', 'Création Mid-Office max'),
    [BookingSearchParameters.whenLastUpdated]: Yii.t('wui-sasha-js', 'Date de dernière mise à jour'),
    whenLastUpdatedMissing: Yii.t('wui-sasha-js', 'Dernière mise à jour'), // just remove to disable checkbox
    whenLastUpdatedMin: Yii.t('wui-sasha-js', 'Dernière m.à.j min'),
    whenLastUpdatedMax: Yii.t('wui-sasha-js', 'Dernière m.à.j max'),
    [BookingSearchParameters.whenIssued]: Yii.t('wui-sasha-js', "Date d'émisson"),
    whenIssuedMin: Yii.t('wui-sasha-js', "Date d'émission min"),
    whenIssuedMax: Yii.t('wui-sasha-js', "Date d'émission max"),
    [BookingSearchParameters.whenToIssue]: Yii.t('wui-sasha-js', "Date d'émission prévue"),
    whenToIssueMissing: Yii.t('wui-sasha-js', "Date d'émission prévue"),
    whenToIssueMin: Yii.t('wui-sasha-js', "Émisson prévue min"),
    whenToIssueMax: Yii.t('wui-sasha-js', "Émission prévue max"),
    [BookingSearchParameters.whenOptionDrops]: Yii.t('wui-sasha-js', "Date d'expiration de l'option"),
    whenOptionDropsMissing: Yii.t('wui-sasha-js', "Date d'expiration de l'option"),
    whenOptionDropsMin: Yii.t('wui-sasha-js', "Expiration de l'option min"),
    whenOptionDropsMax: Yii.t('wui-sasha-js', "Expiration de l'option max"),
    [BookingSearchParameters.whenRetentionEnds]: Yii.t('wui-sasha-js', "Date de fin de rétention"),
    whenRetentionEndsMissing: Yii.t('wui-sasha-js', "Date de fin de rétention"),
    whenRetentionEndsMin: Yii.t('wui-sasha-js', "Fin de rétention min"),
    whenRetentionEndsMax: Yii.t('wui-sasha-js', "Fin de rétention max"),
    [BookingSearchParameters.begin]: Yii.t('wui-sasha-js', 'Date du départ'),
    beginMissing: Yii.t('wui-sasha-js', 'Date du départ'),
    beginMin: Yii.t('wui-sasha-js', 'Départ min'),
    beginMax: Yii.t('wui-sasha-js', 'Départ max'),
    [BookingSearchParameters.end]: Yii.t('wui-sasha-js', "Date de l'arrivée"),
    endMissing: Yii.t('wui-sasha-js', 'Date de l\'arrivée'),
    endMin: Yii.t('wui-sasha-js', 'Arrivée min'),
    endMax: Yii.t('wui-sasha-js', 'Arrivée max'),

    [BookingSearchParameters.whenTravelReallyBegins]: Yii.t('wui-sasha-js', "Date effective de départ"),
    whenTravelReallyBeginsMissing: Yii.t('wui-sasha-js', 'Date effective de départ'),
    whenTravelReallyBeginsMin: Yii.t('wui-sasha-js', 'Date min'),
    whenTravelReallyBeginsMax: Yii.t('wui-sasha-js', 'Date max'),

    [BookingSearchParameters.sectorMatchAll]: Yii.t('wui-sasha-js', 'Recherche de vol exclusive'),
    [BookingSearchParameters.sectorSeatStatus]: Yii.t('wui-sasha-js', 'Statut natif des vols'),
    [BookingSearchParameters.sectorFrom]: Yii.t('wui-sasha-js', "Lieux d'origine"),
    [BookingSearchParameters.sectorTo]: Yii.t('wui-sasha-js', 'Lieux de destination'),
    [BookingSearchParameters.sectorOperatingCarrier]: Yii.t('wui-sasha-js', 'Compagnies opérantes'),
    [BookingSearchParameters.sectorFlightNumber]: Yii.t('wui-sasha-js', 'Numéro de vol'),
    [BookingSearchParameters.sectorCarrier]: Yii.t('wui-sasha-js', 'Compagnies marketing'),
    [BookingSearchParameters.sectorBeginDate]: Yii.t('wui-sasha-js', 'Date de départ'),
    sectorBeginDateMin: Yii.t('wui-sasha-js', 'Départ min'),
    sectorBeginDateMax: Yii.t('wui-sasha-js', 'Départ max'),
    [BookingSearchParameters.sectorArrivalDate]: Yii.t('wui-sasha-js', "Date d'arrivée"),
    sectorArrivalDateMin: Yii.t('wui-sasha-js', 'Arrivée min'),
    sectorArrivalDateMax: Yii.t('wui-sasha-js', 'Arrivée max'),
    [BookingSearchParameters.location]: Yii.t('wui-sasha-js', 'Lieux de passage'),
    [BookingSearchParameters.documentTicket]: Yii.t('wui-sasha-js', 'Numéros de billets'),
    [BookingSearchParameters.pricingRate]: Yii.t('wui-sasha-js', "Type de tarif"),
    [BookingSearchParameters.pricingXState]: Yii.t('wui-sasha-js', "Statuts"),
    [BookingSearchParameters.pricingFarebasis]: Yii.t('wui-sasha-js', "Farebasis"),
    [BookingSearchParameters.serviceCode]: Yii.t('wui-sasha-js', "Codes SSR"),
    [BookingSearchParameters.serviceXStatus]: Yii.t('wui-sasha-js', "Statuts"),
    [BookingSearchParameters.hasSeatAssignment]: Yii.t('wui-sasha-js', 'Réservation de siège'),
    [BookingSearchParameters.whenExecutedOperation]: Yii.t('wui-sasha-js', "Date d'exécution de traitement"),
    whenExecutedOperationMin: Yii.t('wui-sasha-js', "Date d'exécution de traitement min"),
    whenExecutedOperationMax: Yii.t('wui-sasha-js', "Date d'exécution de traitement max"),
    [BookingSearchParameters.serviceCodes]: Yii.t('wui-sasha-js', "Service"),
    [BookingSearchParameters.eligibilityStatuses]: Yii.t('wui-sasha-js', "Critères d'éligibilité "),
    [BookingSearchParameters.operationStatuses]: Yii.t('wui-sasha-js', "Statut de traitement"),
    [BookingSearchParameters.remarkText]: Yii.t('wui-sasha-js', "Toutes les remarques"),
    [BookingSearchParameters.remarkRemark]: Yii.t('wui-sasha-js', "Remarques"),
    [BookingSearchParameters.remarkNote]: Yii.t('wui-sasha-js', "Notes"),
    [BookingSearchParameters.remarkInvoicing]: Yii.t('wui-sasha-js', "Usage interne"),
    [BookingSearchParameters.remarkOsi]: Yii.t('wui-sasha-js', "OSI"),
    [BookingSearchParameters.remarkVendorAlert]: Yii.t('wui-sasha-js', "Alertes fournisseurs"),

    [BookingSearchParameters.propertyReference]: Yii.t('wui-sasha-js', "Références d'hébergement"),
    [BookingSearchParameters.propertyName]: Yii.t('wui-sasha-js', "Noms de l'hébergement"),
    [BookingSearchParameters.placesToStay]: Yii.t('wui-sasha-js', "Lieux de séjour"),
    [BookingSearchParameters.stayBeginDate]: Yii.t('wui-sasha-js', "Date de départ"),
    [BookingSearchParameters.stayArrivalDate]: Yii.t('wui-sasha-js', "Date d'arrivée"),
    stayBeginDateMissing: Yii.t('wui-sasha-js', "Date de départ"),
    stayBeginDateMin: Yii.t('wui-sasha-js', "Départ min"),
    stayBeginDateMax: Yii.t('wui-sasha-js', "Départ max"),
    stayArrivalDateMissing: Yii.t('wui-sasha-js', "Date d'arrivée"),
    stayArrivalDateMin: Yii.t('wui-sasha-js', "Arrivée min"),
    stayArrivalDateMax: Yii.t('wui-sasha-js', "Arrivée max"),
    [BookingSearchParameters.hasFareOptimisation]: Yii.t('wui-sasha-js', 'Optimisation'),
    [BookingSearchParameters.actionForFareOptimisation]: Yii.t('wui-sasha-js', "Type d'optimisation"),
    [BookingSearchParameters.savingMin]: Yii.t('wui-sasha-js', 'Gain minimum par optimisation'),
    [BookingSearchParameters.impactOnFareType]: Yii.t('wui-sasha-js', 'Type de tarif'),
    [BookingSearchParameters.impactOnLuggage]: Yii.t('wui-sasha-js', 'Bagages'),

    [BookingSearchParameters.qualityCheck]: Yii.t('wui-sasha-js', "Contrôle"),

};

export const FIELD_PLURAL_LABELS: { [key: string]: string } = {
    [BookingSearchParameters.qualityCheck]: Yii.t('wui-sasha-js', "Contrôles"),
};

const SUPPORTS_WILDCARD: string = Yii.t("wui-sasha-js", "* pour rechercher un texte partiel.");
const SUPPORTS_NOT: string = Yii.t("wui-sasha-js", "NOT ou un tiret au début d'un mot pour rechercher des valeurs qui ne contiennent pas ce mot.");
const SUPPORTS_AND: string = Yii.t("wui-sasha-js", "AND pour combiner des expressions");

/**
 * FIELD DESCRIPTIONS TRANSLATED
 */
export const FIELD_DESCRIPTION_LABELS: { [key: string]: IDescriptionLabels } = {
    [BookingSearchParameters.code]: {
        main: Yii.t('wui-sasha-js', "Recherche d'un dossier depuis sa référence"),
        detailIntroduction: Yii.t('wui-sasha-js', "Recherche un dossier à partir de sa référence\xa0:"),
        detailList: [
            Yii.t('wui-sasha-js', "Numéro de PNR"),
            Yii.t('wui-sasha-js', "Numéro de dossier hôtelier"),
            Yii.t('wui-sasha-js', "Référence de dossier Mid-Office"),
            Yii.t('wui-sasha-js', "…"),
        ],
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    [BookingSearchParameters.text]: {
        main: Yii.t('wui-sasha-js', "Champ de recherche global."),
        detailIntroduction: Yii.t('wui-sasha-js', "Ce champ cherche dans les dossiers les informations suivantes\xa0:"),
        // For information \xa0 is the unicode representation of a non-break space (equivalent of &nbsp;)
        detailList: [
            Yii.t('wui-sasha-js', "références de dossier\xa0;"),
            Yii.t('wui-sasha-js', "noms de dossier, client, voyageur, agent, agence, marque\xa0;"),
            Yii.t('wui-sasha-js', "références d'agence, d'agent, de marque\xa0;"),
            Yii.t('wui-sasha-js', "numéros de télephone de client, de voyageur, d'agent\xa0;"),
            Yii.t('wui-sasha-js', "adresses email de client, de voyageur, d'agent\xa0;"),
            Yii.t('wui-sasha-js', "compagnies aériennes\xa0: codes ou noms\xa0;"),
            Yii.t('wui-sasha-js', "lieux\xa0: codes ou noms d'aéroports, de villes, de pays\xa0;"),
            Yii.t('wui-sasha-js', "statuts natifs de segments."),
        ],
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    // Booking
    [BookingSearchParameters.host]: {
        main: Yii.t('wui-sasha-js', "Systèmes avec lesquels les dossiers ont été créés."),
    },
    [BookingSearchParameters.type]: {
        main: Yii.t('wui-sasha-js', "Types de prestations contenus dans les dossiers"),
    },
    [BookingSearchParameters.xType]: {
        main: Yii.t('wui-sasha-js', "Rechercher des dossiers individuels ou au contraire des dossiers de groupe."),
    },
    [BookingSearchParameters.xStatus]: {
        main: Yii.t('wui-sasha-js', "Recherche selon l’état des dossiers de réservation au moment où on effectue la recherche."),
    },
    [BookingSearchParameters.midOffice]: {
        main: Yii.t('wui-sasha-js', "Statut du dossier dans le système interne de gestion commerciale ou de facturation.")
    },
    [BookingSearchParameters.issueStatus]: {
        main: Yii.t('wui-sasha-js', "Statut d'émission d'un dossier."),
        detailIntroduction: Yii.t('wui-sasha-js', "Attention, le statut d'émission n'est disponible que pour les réservation qui doivent faire l’objet d’une émission de document (par exemple les réservations aériennes)."),
    },
    [BookingSearchParameters.retentionReason]: {
        main: Yii.t('wui-sasha-js', "Raison de rétention d'un dossier."),
        detailIntroduction: Yii.t('wui-sasha-js',
            "Recherche selon la raison évoquée dans le segment de rétention. Concerne uniquement les dossiers aériens."),
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    [BookingSearchParameters.agent]: {
        main: Yii.t('wui-sasha-js', "Champ de recherche des agents."),
        detailIntroduction: Yii.t('wui-sasha-js', "Ce champ cherche dans les dossiers les informations suivantes\xa0:"),
        detailList: [
            Yii.t('wui-sasha-js', "noms d'agents\xa0;"),
            Yii.t('wui-sasha-js', "références d'agents\xa0;"),
            Yii.t('wui-sasha-js', "numéros de télephone d'agents\xa0;"),
            Yii.t('wui-sasha-js', "adresses email d'agents."),
        ],
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    agentList: {
        main: Yii.t('wui-sasha-js', "Champ de recherche des agents."),
        detailIntroduction: Yii.t('wui-sasha-js', "Vous pouvez choisir les agents sur lequels faire votre recherche."),

    },
    [BookingSearchParameters.agency]: {
        main: Yii.t('wui-sasha-js', "Champ de recherche des agences."),
        detailIntroduction: Yii.t('wui-sasha-js', "Ce champ cherche dans les dossiers les informations suivantes\xa0:"),
        detailList: [
            Yii.t('wui-sasha-js', "noms d'agences\xa0;"),
            Yii.t('wui-sasha-js', "références d'agences\xa0;"),
            Yii.t('wui-sasha-js', "numéros de télephone d'agences\xa0;"),
            Yii.t('wui-sasha-js', "adresses email d'agences."),
        ],
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    agencyList: {
        main: Yii.t('wui-sasha-js', "Champ de recherche des agences."),
        detailIntroduction: Yii.t('wui-sasha-js', "Vous pouvez choisir les agences sur lequelles faire votre recherche."),
    },
    [BookingSearchParameters.pendingPercentageMax]: {
        main: Yii.t('wui-sasha-js', "Pourcentage de la somme approximative totale des billets du dossier correspondant aux coupons qui n'ont pas encore été consommés, Maximum."),
    },
    [BookingSearchParameters.pendingPercentageMin]: {
        main: Yii.t('wui-sasha-js', "Pourcentage de la somme approximative totale des billets du dossier correspondant aux coupons qui n'ont pas encore été consommés, Minimum."),
    },
    [BookingSearchParameters.pendingValueMax]: {
        main: Yii.t('wui-sasha-js', "Somme approximative totale des billets du dossier correspondant aux coupons qui n'ont pas encore été consommés, Maximum."),
    },
    [BookingSearchParameters.pendingValueMin]: {
        main: Yii.t('wui-sasha-js', "Somme approximative totale des billets du dossier correspondant aux coupons qui n'ont pas encore été consommés, Minimum."),
    },
    [BookingSearchParameters.paidPercentageMax]: {
        main: Yii.t('wui-sasha-js', "Paiement efféctué par le client en pourcentage, Maximum."),
    },
    [BookingSearchParameters.paidPercentageMin]: {
        main: Yii.t('wui-sasha-js', "Paiement efféctué par le client en pourcentage, Minimum."),
    },
    [BookingSearchParameters.paidValueMax]: {
        main: Yii.t('wui-sasha-js', "Paiement efféctué par le client, Maximum."),
    },
    [BookingSearchParameters.paidValueMin]: {
        main: Yii.t('wui-sasha-js', "Paiement efféctué par le client, Minimum."),
    },
    [BookingSearchParameters.duePercentageMax]: {
        main: Yii.t('wui-sasha-js', "Paiement restant à régler par le client en pourcentage, Maximum."),
    },
    [BookingSearchParameters.duePercentageMin]: {
        main: Yii.t('wui-sasha-js', "Paiement restant à régler par le client en pourcentage, Minimum."),
    },
    [BookingSearchParameters.dueValueMax]: {
        main: Yii.t('wui-sasha-js', "Paiement restant à régler par le client, Maximum."),
    },
    [BookingSearchParameters.dueValueMin]: {
        main: Yii.t('wui-sasha-js', "Paiement restant à régler par le client, Minimum."),
    },

    whenCreatedMin: {
        main: Yii.t('wui-sasha-js', "Pour indiquer la date à partir de laquelle les dossiers ont été créés."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    whenAgencyBookingCreatedMin: {
        main: Yii.t('wui-sasha-js', "Pour indiquer la date à partir de laquelle les dossiers ont été créés."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    whenCreatedMax: {
        main: Yii.t('wui-sasha-js', "Pour indiquer la date butoir de création des dossiers."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    whenAgencyBookingCreatedMax: {
        main: Yii.t('wui-sasha-js', "Pour indiquer la date butoir de création des dossiers."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    whenLastUpdatedMissing: {
        main: Yii.t('wui-sasha-js', "Pour indiquer si la date de dernière mise à jour est absente."),
    },
    whenLastUpdatedMin: {
        main: Yii.t('wui-sasha-js', "Pour indiquer la date à partir de laquelle les dossiers ont été mis à jour pour la dernière fois."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    whenLastUpdatedMax: {
        main: Yii.t('wui-sasha-js', "Pour indiquer la date butoir de mise à jour des dossiers."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    whenIssuedMin: {
        main: Yii.t('wui-sasha-js', "Pour indiquer la date à partir de laquelle les dossiers ont été émis."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    whenIssuedMax: {
        main: Yii.t('wui-sasha-js', "Pour indiquer la date butoir d’émission des dossiers."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    whenToIssueMissing: {
        main: Yii.t('wui-sasha-js', "Pour indiquer si la date à partir de laquelle l’émission est prévue est absente."),
    },
    whenToIssueMin: {
        main: Yii.t('wui-sasha-js', "Pour indiquer la date à partir de laquelle l’émission est prévue."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    whenToIssueMax: {
        main: Yii.t('wui-sasha-js', "Pour indiquer la date butoir à laquelle l’émission est prévue."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    whenOptionDropsMissing: {
        main: Yii.t('wui-sasha-js', "Pour indiquer si la date à partir de laquelle les options expirent est absente."),
    },
    whenOptionDropsMin: {
        main: Yii.t('wui-sasha-js', "Pour indiquer la date à partir de laquelle les options expirent."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    whenOptionDropsMax: {
        main: Yii.t('wui-sasha-js', "Pour indiquer la date butoir d'expiration des options."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    whenRetentionEndsMissing: {
        main: Yii.t('wui-sasha-js', "Pour indiquer si la date à partir de laquelle la rétention s'achève est absente."),
    },
    whenRetentionEndsMin: {
        main: Yii.t('wui-sasha-js', "Pour indiquer la date à partir de laquelle la rétention s'achève."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    whenRetentionEndsMax: {
        main: Yii.t('wui-sasha-js', "Pour indiquer la date butoir de fin de rétention."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    // Persons
    [BookingSearchParameters.person]: {
        main: Yii.t('wui-sasha-js', "Champ de recherche de voyageurs ou de clients."),
        detailIntroduction: Yii.t('wui-sasha-js', "Ce champ cherche dans les dossiers les informations suivantes\xa0:"),
        detailList: [
            Yii.t('wui-sasha-js', "noms de voyageurs ou de clients\xa0;"),
            Yii.t('wui-sasha-js', "références de voyageurs ou de clients\xa0;"),
            Yii.t('wui-sasha-js', "télephones de voyageurs ou de clients\xa0;"),
            Yii.t('wui-sasha-js', "adresses email de voyageurs ou de clients\xa0;"),
            Yii.t('wui-sasha-js', "numéros de cartes frequent flyer\xa0;"),
            Yii.t('wui-sasha-js', "numéros de billet."),
        ],
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    // Documents
    [BookingSearchParameters.documentTicket]: {
        main: Yii.t('wui-sasha-js', "Permet de rechercher des numéros de billets."),
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    // Pricing
    [BookingSearchParameters.pricingRate]: {
        main: Yii.t('wui-sasha-js', "Permet de rechercher des dossiers selon le type de tarif appliqué."),
    },
    [BookingSearchParameters.pricingXState]: {
        main: Yii.t('wui-sasha-js', "Permet de rechercher les dossiers selon les statuts des tarifs du dossier."),
    },
    [BookingSearchParameters.pricingFarebasis]: {
        main: Yii.t('wui-sasha-js', "Pour indiquer des codes de farebasis."),
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    // Journey
    [BookingSearchParameters.from]: {
        main: Yii.t('wui-sasha-js', "Ce champ permet de préciser les lieux de départ du voyage."),
        detailIntroduction: [
            Yii.t("wui-sasha-js", "Vous pouvez rechercher des codes ou des noms d'aéroports, de villes et de pays."),
            Yii.t('wui-sasha-js', "Pour des recherches plus précises sur les dossiers aériens, utiliser les critères associés au vols."),
        ],
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    [BookingSearchParameters.to]: {
        main: Yii.t('wui-sasha-js', "Ce champ permet de préciser les les lieux d'arrivée du voyage."),
        detailIntroduction: [
            Yii.t("wui-sasha-js", "Vous pouvez rechercher des codes ou des noms d'aéroports, de villes et de pays."),
            Yii.t('wui-sasha-js', "Pour des recherches plus précises sur les dossiers aériens, utiliser les critères associés au vols."),
        ],
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    [BookingSearchParameters.location]: {
        main: Yii.t('wui-sasha-js', "Ce champ permet de préciser lieux par lesquels les voyageurs vont passer (départ, arrivée, escale)."),
        detailIntroduction: [
            Yii.t("wui-sasha-js", "Vous pouvez rechercher des codes ou des noms d'aéroports, de villes et de pays."),
            Yii.t('wui-sasha-js', "Pour des recherches plus précises sur les dossiers aériens, utiliser les critères associés au vols."),
        ],
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    beginMissing: {
        main: Yii.t('wui-sasha-js', "Pour indiquer si la date de départ de voyage est absente."),
    },
    beginMin: {
        main: Yii.t("wui-sasha-js", "Pour indiquer la date de départ minimale de voyage sur laquelle effectuer la recherche."),
        detailIntroduction: Yii.t("wui-sasha-js", "Pour des recherches plus précises sur les dossiers aériens, utiliser les critères associés au vols. ")
            + DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    beginMax: {
        main: Yii.t("wui-sasha-js", "Pour indiquer la date de départ butoir de voyage sur laquelle effectuer la recherche."),
        detailIntroduction: Yii.t("wui-sasha-js", "Pour des recherches plus précises sur les dossiers aériens, utiliser les critères associés au vols. ")
            + DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    endMissing: {
        main: Yii.t('wui-sasha-js', "Pour indiquer si la date d'arrivée de voyage est absente."),
    },
    endMin: {
        main: Yii.t("wui-sasha-js", "Pour indiquer la date d'arrivée minimale de voyage sur laquelle effectuer la recherche."),
        detailIntroduction: Yii.t("wui-sasha-js", "Pour des recherches plus précises sur les dossiers aériens, utiliser les critères associés au vols. ")
            + DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    endMax: {
        main: Yii.t("wui-sasha-js", "Pour indiquer la date d'arrivée butoir de voyage sur laquelle effectuer la recherche."),
        detailIntroduction: Yii.t("wui-sasha-js", "Pour des recherches plus précises sur les dossiers aériens, utiliser les critères associés au vols. ")
            + DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },

    whenTravelReallyBeginsMissing: {
        main: Yii.t('wui-sasha-js', "Pour indiquer si la date de départ effective de voyage est absente."),
    },
    whenTravelReallyBeginsMin: {
        main: Yii.t("wui-sasha-js", "Pour indiquer la date de départ effective minimale de voyage sur laquelle effectuer la recherche."),
        detailIntroduction: Yii.t("wui-sasha-js", "Pour des recherches plus précises sur les dossiers aériens, utiliser les critères associés au vols. ")
            + DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    whenTravelReallyBeginsMax: {
        main: Yii.t("wui-sasha-js", "Pour indiquer la date de départ effective butoir de voyage sur laquelle effectuer la recherche."),
        detailIntroduction: Yii.t("wui-sasha-js", "Pour des recherches plus précises sur les dossiers aériens, utiliser les critères associés au vols. ")
            + DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },

    carrier: {
        main: Yii.t("wui-sasha-js", "Pour indiquer la compagnie principale du voyage."),
        detailIntroduction: Yii.t("wui-sasha-js", "Pour des recherches plus précises sur les dossiers aériens, utiliser les critères associés au vols."),
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    [BookingSearchParameters.seatStatus]: {
        main: Yii.t("wui-sasha-js", "Pour indiquer les statuts natifs des sièges de tous les vols du voyage."),
        detailIntroduction: Yii.t("wui-sasha-js", "Pour des recherches plus précises sur les dossiers aériens, utiliser les critères associés au vols."),
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    // Flights
    [BookingSearchParameters.sectorMatchAll]: {
        main: Yii.t("wui-sasha-js", `Si coché, seuls les dossiers où tous les vols correspondent aux critères seront remontés. Si décoché, il suffit qu'un des vols corresponde aux critères.`),
    },
    [BookingSearchParameters.ticketMatchAll]: {
        main: Yii.t("wui-sasha-js", `Si coché, seuls les dossiers où tous les coupons correspondent aux critères seront remontés. Si décoché, il suffit qu'un des coupons corresponde aux critères.`),
    },

    [BookingSearchParameters.sectorSeatStatus]: {
        main: Yii.t("wui-sasha-js", "Permet de rechercher en fonction du statut tel qu’il figure dans le GDS (par exemple HK, HX, TK, KK, …)."),
    },
    [BookingSearchParameters.sectorFlightNumber]: {
        main: Yii.t("wui-sasha-js", "Permet de rechercher un dossier d'après un numéro de vol d'un des secteurs."),
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    [BookingSearchParameters.sectorFrom]: {
        main: Yii.t("wui-sasha-js", "Ce champ permet de préciser les lieux de départ du parcours aérien."),
        detailIntroduction: [
            Yii.t("wui-sasha-js", "Vous pouvez rechercher des codes ou des noms d'aéroports, de villes et de pays."),
            Yii.t("wui-sasha-js", "Ce champ supporte la recherche à partir d'un code ou un nom partiel, en utilisant le caractère étoile (*)."),
        ],
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    [BookingSearchParameters.ticketSectorFrom]: {
        main: Yii.t("wui-sasha-js", "Ce champ permet de préciser les lieux de départ du parcours aérien."),
        detailIntroduction: [
            Yii.t("wui-sasha-js", "Vous pouvez rechercher des codes ou des noms d'aéroports, de villes et de pays."),
            Yii.t("wui-sasha-js", "Ce champ supporte la recherche à partir d'un code ou un nom partiel, en utilisant le caractère étoile (*)."),
        ],
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    [BookingSearchParameters.ticketSectorTo]: {
        main: Yii.t("wui-sasha-js", "Ce champ permet de préciser les lieux de départ du parcours aérien."),
        detailIntroduction: [
            Yii.t("wui-sasha-js", "Vous pouvez rechercher des codes ou des noms d'aéroports, de villes et de pays."),
            Yii.t("wui-sasha-js", "Ce champ supporte la recherche à partir d'un code ou un nom partiel, en utilisant le caractère étoile (*)."),
        ],
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },

    [BookingSearchParameters.ticketStatus]: {
        main: Yii.t("wui-sasha-js", "Permet de rechercher en fonction du statut)."),
        detailIntroduction: [
            Yii.t("wui-sasha-js", "codes possibles"),
            Yii.t("wui-sasha-js", "OPENFORUSE / OPEN"),
            Yii.t("wui-sasha-js", "AIRPORTCONTROL/ ARPT"),
            Yii.t("wui-sasha-js", "CHECKEDIN / CKIN"),
            Yii.t("wui-sasha-js", "BOARDED / LFTD"),
            Yii.t("wui-sasha-js", "NOTIFIED"),
            Yii.t("wui-sasha-js", "IRREGULAROPERATIONS / IREG"),
            Yii.t("wui-sasha-js", "SUSPENDED / SUSP"),
            Yii.t("wui-sasha-js", "UNAVAILABLE / UNVL"),
            Yii.t("wui-sasha-js", "USED / FLWN"),
            Yii.t("wui-sasha-js", "REFUNDED"),
            Yii.t("wui-sasha-js", "CLOSED / CLSD"),
            Yii.t("wui-sasha-js", "CONVERTEDTOFIM"),
            Yii.t("wui-sasha-js", "PRINTED / PRTD"),
            Yii.t("wui-sasha-js", "EXCH / EXCHANGED"),
        ],
    },
    [BookingSearchParameters.ticketNativeStatus]: {
        main: Yii.t("wui-sasha-js", "Permet de rechercher en fonction du statut des coupons du vol)."),
        detailIntroduction: [
            Yii.t("wui-sasha-js", "codes possibles"),
            Yii.t("wui-sasha-js", "OPENFORUSE / OPEN"),
            Yii.t("wui-sasha-js", "AIRPORTCONTROL/ ARPT"),
            Yii.t("wui-sasha-js", "CHECKEDIN / CKIN"),
            Yii.t("wui-sasha-js", "BOARDED / LFTD"),
            Yii.t("wui-sasha-js", "NOTIFIED"),
            Yii.t("wui-sasha-js", "IRREGULAROPERATIONS / IREG"),
            Yii.t("wui-sasha-js", "SUSPENDED / SUSP"),
            Yii.t("wui-sasha-js", "UNAVAILABLE / UNVL"),
            Yii.t("wui-sasha-js", "USED / FLWN"),
            Yii.t("wui-sasha-js", "REFUNDED"),
            Yii.t("wui-sasha-js", "CLOSED / CLSD"),
            Yii.t("wui-sasha-js", "CONVERTEDTOFIM"),
            Yii.t("wui-sasha-js", "PRINTED / PRTD"),
            Yii.t("wui-sasha-js", "EXCH / EXCHANGED"),
        ],
    },
    [BookingSearchParameters.ticketFlightNumber]: {
        main: Yii.t("wui-sasha-js", "Permet de rechercher un dossier d'après un numéro de vol d'un des tickets."),
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },

    [BookingSearchParameters.ticketSectorCarrier]: {
        main: Yii.t("wui-sasha-js", "Pour rechercher selon la compagnie qui figure dans le numéro de vol."),
        detailIntroduction: [
            Yii.t("wui-sasha-js", "Vous pouvez rechercher des codes ou des noms de compagnies aériennes."),
            Yii.t("wui-sasha-js", "Ce champ supporte la recherche à partir d'un code ou un nom partiel, en utilisant le caractère étoile (*)."),
        ],
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },

    [BookingSearchParameters.sectorTo]: {
        main: Yii.t("wui-sasha-js", "Ce champ permet de préciser les lieux d'arrivée du parcours aérien."),
        detailIntroduction: [
            Yii.t("wui-sasha-js", "Vous pouvez rechercher des codes ou des noms d'aéroports, de villes et de pays."),
            Yii.t("wui-sasha-js", "Ce champ supporte la recherche à partir d'un code ou un nom partiel, en utilisant le caractère étoile (*)."),
        ],
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    [BookingSearchParameters.sectorOperatingCarrier]: {
        main: Yii.t("wui-sasha-js", "Pour rechercher selon la compagnie qui possède l’appareil qui effectue le parcours."),
        detailIntroduction: [
            Yii.t("wui-sasha-js", "Vous pouvez rechercher des codes ou des noms de compagnies aériennes."),
            Yii.t("wui-sasha-js", "Ce champ supporte la recherche à partir d'un code ou un nom partiel, en utilisant le caractère étoile (*)."),
        ],
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    [BookingSearchParameters.sectorCarrier]: {
        main: Yii.t("wui-sasha-js", "Pour rechercher selon la compagnie qui figure dans le numéro de vol."),
        detailIntroduction: [
            Yii.t("wui-sasha-js", "Vous pouvez rechercher des codes ou des noms de compagnies aériennes."),
            Yii.t("wui-sasha-js", "Ce champ supporte la recherche à partir d'un code ou un nom partiel, en utilisant le caractère étoile (*)."),
        ],
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },

    ticketSectorBeginDateMin: {
        main: Yii.t("wui-sasha-js", "Pour indiquer la date de départ minimale de parcours sur laquelle effectuer la recherche."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    ticketSectorBeginDateMax: {
        main: Yii.t("wui-sasha-js", "Pour indiquer la date de départ butoir de parcours sur laquelle effectuer la recherche."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },

    sectorBeginDateMin: {
        main: Yii.t("wui-sasha-js", "Pour indiquer la date de départ minimale de parcours sur laquelle effectuer la recherche."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    sectorBeginDateMax: {
        main: Yii.t("wui-sasha-js", "Pour indiquer la date de départ butoir de parcours sur laquelle effectuer la recherche."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    sectorArrivalDateMin: {
        main: Yii.t("wui-sasha-js", "Pour indiquer la date d’arrivée minimale de parcours sur laquelle effectuer la recherche."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    sectorArrivalDateMax: {
        main: Yii.t("wui-sasha-js", "Pour indiquer la date d’arrivée minimale de parcours sur laquelle effectuer la recherche."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    // Service
    [BookingSearchParameters.serviceCode]: {
        main: Yii.t('wui-sasha-js', "Pour rechercher un dossier à partir de sa référence (en principe unique)\xa0: un numéro de PNR, un numéro de dossier hôtelier, une référence de dossier Mid-Office…"),
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    [BookingSearchParameters.serviceXStatus]: {
        main: Yii.t('wui-sasha-js', "Pour rechercher un dossier à partir de sa référence (en principe unique)\xa0: un numéro de PNR, un numéro de dossier hôtelier, une référence de dossier Mid-Office…"),
    },
    // service Afidium
    [BookingSearchParameters.serviceCodes]: {
        main: Yii.t('wui-sasha-js', "Liste des services disponibles a la recherche"),
    },
    // Critères d'éligibilité
    [BookingSearchParameters.eligibilityStatuses]: {
        main: Yii.t('wui-sasha-js', "Critères d'éligibilité du service"),
    },
    // Statut de traitement
    [BookingSearchParameters.operationStatuses]: {
        main: Yii.t('wui-sasha-js', "Statut de traitement du service"),
    },
    // Date min traitement
    whenExecutedOperationMin: {
        main: Yii.t('wui-sasha-js', "Pour indiquer la date de traitement minimale sur laquelle effectuer la recherche."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    // Date max traitement
    whenExecutedOperationMax: {
        main: Yii.t('wui-sasha-js', "Pour indiquer la date de traitement maximale sur laquelle effectuer la recherche."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    [BookingSearchParameters.remarkText]: {
        main: Yii.t('wui-sasha-js', 'Recherche un texte dans toutes les remarques du dossier.'),
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    [BookingSearchParameters.remarkRemark]: {
        main: Yii.t('wui-sasha-js', 'Recherche un texte dans les remarques du dossier.'),
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    [BookingSearchParameters.remarkInvoicing]: {
        main: Yii.t('wui-sasha-js', 'Recherche un texte dans les remarques à usage interne.'),
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    [BookingSearchParameters.remarkNote]: {
        main: Yii.t('wui-sasha-js', 'Recherche un texte dans les notes du dossier.'),
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    [BookingSearchParameters.remarkOsi]: {
        main: Yii.t('wui-sasha-js', 'Recherche un texte dans les champs OSI du dossier.'),
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },
    [BookingSearchParameters.remarkVendorAlert]: {
        main: Yii.t('wui-sasha-js', 'Recherche un texte dans les alertes fournisseurs du dossier.'),
        syntaxHelp: [
            SUPPORTS_NOT,
            SUPPORTS_WILDCARD,
            SUPPORTS_AND,
        ],
    },

    //Accommodation
    [BookingSearchParameters.placesToStay]: {
        main: Yii.t('wui-sasha-js', "Ce champ permet de cibler sur les lieux dans lesquels les voyageurs vont séjourner (adresse de l'hébergement).\n Vous pouvez rechercher des noms de villes, d'état ou de pays."),
        detailIntroduction: STAY_EXPRESSION_FIELD_INTRO,
        detailList: STAY_EXPRESSION_DETAILS,
    },
    [BookingSearchParameters.propertyReference]: {
        main: Yii.t('wui-sasha-js', "Ce champ permet de cibler sur des codes d'hébergement (code natif de l'hébergement chez le fournisseur ou code système Afidium)"),
        detailIntroduction: STAY_EXPRESSION_FIELD_INTRO,
        detailList: STAY_EXPRESSION_DETAILS,
    },
    [BookingSearchParameters.propertyName]: {
        main: Yii.t('wui-sasha-js', "Ce champ permet de cibler sur le nom d'hébergement chez le fournisseur (un même hébergement peut avoir des noms légèrement différents d'un fournisseur à l'autre"),
        detailIntroduction: STAY_EXPRESSION_FIELD_INTRO,
        detailList: STAY_EXPRESSION_DETAILS,
    },
    stayBeginDateMissing: {
        main: Yii.t('wui-sasha-js', "Pour indiquer si la date de départ de l'hébergement est absente."),
    },
    stayBeginDateMin: {
        main: Yii.t("wui-sasha-js", "Pour indiquer la date minimale de départ de l'hébergement, sur laquelle effectuer la recherche."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    stayBeginDateMax: {
        main: Yii.t("wui-sasha-js", "Pour indiquer la date butoir de départ de l'hébergement, sur laquelle effectuer la recherche."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    stayArrivalDateMissing: {
        main: Yii.t('wui-sasha-js', "Pour indiquer si la date d'arrivée est absente."),
    },
    stayArrivalDateMin: {
        main: Yii.t("wui-sasha-js", "Pour indiquer la date d'arrivée minimale sur laquelle effectuer la recherche."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    stayArrivalDateMax: {
        main: Yii.t("wui-sasha-js", "Pour indiquer la date butoir d'arrivée sur laquelle effectuer la recherche."),
        detailIntroduction: DATE_EXPRESSION_FIELD_INTRO,
        detailList: DATE_EXPRESSION_DETAILS,
    },
    //Fare Optimisation
    [BookingSearchParameters.hasFareOptimisation]: {
        main: Yii.t('wui-sasha-js', "Uniquement les dossiers ayant une optimisation tarifaire."),
    },
    [BookingSearchParameters.actionForFareOptimisation]: {
        main: Yii.t('wui-sasha-js', "Pour rechercher un dossier à partir de son type d'optimisation."),
    },
    [BookingSearchParameters.savingMin]: {
        main: Yii.t('wui-sasha-js', "Gain minimum par optimisation"),
    },
    [BookingSearchParameters.impactOnLuggage]: {
        main: Yii.t('wui-sasha-js', "Bagages."),
    },
    [BookingSearchParameters.impactOnFareType]: {
        main: Yii.t('wui-sasha-js', "Type de tarif."),
    },
    //Quality check
    [BookingSearchParameters.qualityCheck]: {
        main: Yii.t('wui-sasha-js', "placeholder test ..."),

    },
};

export const FIELD_CHECKBOX_LABELS: { [key: string]: string } = {
    [BookingSearchParameters.sectorMatchAll]: Yii.t('wui-sasha-js', 'Tous les vols doivent correspondre à ces critères.'),
    [BookingSearchParameters.ticketMatchAll]: Yii.t('wui-sasha-js', 'Tous les coupons doivent correspondre à ces critères'),
    [BookingSearchParameters.hasFareOptimisation]: Yii.t('wui-sasha-js', 'Une optimisation est possible'),
};
